import { UploadBaseIcon } from '@tableau/icons/UploadBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { FileInput, FileInputProps } from '~src/userManagement/components/FileInput';

import { fileUploadStyle } from '../styles/CustomDomainStyles';

export type FileUploadProps = FileInputProps & {
  promptText: string;
};

export class FileUpload extends React.Component<FileUploadProps, {}> {
  private fileInput: React.RefObject<HTMLInputElement>;
  private boundHandleButtonClick: () => void;

  public constructor(props: FileUploadProps) {
    super(props);
    this.fileInput = React.createRef();
    this.boundHandleButtonClick = this.handleButtonClick.bind(this);
  }

  /**
   * Handles the click event on the visible button by sending a click event to the hidden file input.
   */
  private handleButtonClick(): void {
    this.fileInput.current.click();
  }

  public render(): JSX.Element {
    const { promptText, ...fileInputProps } = this.props;
    return (
        <>
        <ButtonWidget
            handleClick={this.boundHandleButtonClick}
            testId={this.props.testId}
            buttonType={ButtonType.Outline}
            style={{paddingLeft:12, paddingRight:12}}
        >
            <div style={fileUploadStyle}>
              <UploadBaseIcon size={12} style={{marginRight:5}}/>
              {this.props.promptText}
            </div>
        </ButtonWidget>
        <FileInput
            {...fileInputProps}
            ref={this.fileInput}
            testId={'FileInput-' + this.props.testId}
        />
        </>
    );
  }
}
